import { Routes } from "@/apps/admin/router/routes";
import type { Router } from "vue-router";
import { useUserStore } from "@/store";

export function configureRouter(router: Router): void {
  router.beforeEach((to) => {
    if (!to.path.startsWith(Routes.index)) return;

    // 检查登录
    if (useUserStore().isSignedIn) return;

    // 白名单
    if (([Routes.login] as string[]).includes(to.path)) return;

    router.push(Routes.login);
  });
}
